const FileManager = () =>
  import(
    /* webpackChunkName: "blog-file-and-documents" */ '@/pages/blog/file-and-documents/index.vue'
  )
const FileManagerEdit = () =>
  import(
    /* webpackChunkName: "blog-file-and-documents" */ '@/pages/blog/file-and-documents/media.vue'
  )

export default {
  path: 'file-and-documents',
  meta: {
    label: 'fileAndDocuments',
    auth: 'doc'
  },
  component: {
    name: 'BlogDocument',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'BlogFileAndDocuments',
      path: '',
      meta: {
        label: 'fileAndDocuments',
        auth: 'root'
      },
      component: FileManager
    },
    {
      name: 'BlogEditFileAndDocuments',
      path: ':root',
      meta: {
        label: 'edit',
        auth: 'root'
      },
      props: true,
      component: FileManagerEdit
    }
  ]
}
